import React, { useState } from "react"
import styled from "styled-components"

import { Container, Section } from "../global"
import addToMailchimp from "gatsby-plugin-mailchimp"

const GetStarted = () => {
  const [email, setEmail] = useState("")
  const [errors, setErrors] = useState("")
  const [subscribed, setSubscriptionStatus] = useState(false)
  const [afterSubscriptionMessage, setAfterSubscriptionMessage] = useState("")

  const isEmailValid = email => {
    const expression = /\S+@\S+/
    return expression.test(String(email).toLowerCase())
  }

  const handleResult = promise => {
    const status = promise.result
    setSubscriptionStatus(true)
    switch (status) {
      case "success":
        setAfterSubscriptionMessage("Thank you for subscribing!")
        break
      default:
        setAfterSubscriptionMessage("Looks like you are already subscribed!")
        break
    }
  }

  const handleSubmit = async event => {
    event.preventDefault()
    if (isEmailValid) {
      const result = await addToMailchimp(email)
      handleResult(result)
    } else {
      setErrors("Enter a valid email address")
    }
  }
  return (
    <StyledSection id="get-started">
      <GetStartedContainer>
        {subscribed ? (
          <GetStartedTitle>{afterSubscriptionMessage}</GetStartedTitle>
        ) : (
          <>
            <GetStartedTitle>Let’s keep in touch</GetStartedTitle>
            <Subtitle>
              Join the email list and don’t miss any app update.
            </Subtitle>
            <HeaderForm onSubmit={handleSubmit}>
              <HeaderInput
                placeholder="Email address"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <HeaderButton>SUBSCRIBE</HeaderButton>
            </HeaderForm>
            <FormSubtitle>{errors}</FormSubtitle>
          </>
        )}
      </GetStartedContainer>
    </StyledSection>
  )
}

export default GetStarted

const StyledSection = styled(Section)`
  background-color: ${props => props.theme.color.background.light};
  clip-path: polygon(0 0, 100% 14%, 100% 100%, 0% 100%);
`

const GetStartedContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 0 80px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    padding: 40px 0 40px;
  }
`

const GetStartedTitle = styled.h3`
  margin: 0 auto 0px;
  text-align: center;
  @media (max-width: ${props => props.theme.screen.sm}) {
    ${props => props.theme.font_size.regular}
  }
`

const Subtitle = styled.span`
  ${props => props.theme.font_size.xxsmall}
  /* padding-top: 16px;
  padding-bottom: 16px; */
  padding: 16px 0;
  font-size: 14px;
  color: ${props => props.theme.color.primary};
`

const HeaderForm = styled.form`
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;
  width: 50vw;
  @media (max-width: ${props => props.theme.screen.sm}) {
    flex-direction: column;
    width: 68vw;
  }
`

const HeaderInput = styled.input`
  font-weight: 500;
  font-size: 16px;
  color: ${props => props.theme.color.primary};
  line-height: 42px;
  width: 100%;
  text-align: left;
  height: 60px;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => props.theme.color.yellow};
  border-image: initial;
  border-radius: 4px 0 0 4px;
  padding: 8px 0px 8px 16px;
  outline: 0px;
  &:focus {
    box-shadow: inset ${props => props.theme.color.yellow} 0px 0px 0px 2px;
  }
  @media (max-width: ${props => props.theme.screen.md}) {
    margin-bottom: 8px;
    padding: 8px 0px 8px 16px;
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    display: block;
    width: 100%;
    border-radius: 4px;
  }
`

const HeaderButton = styled.button`
  font-weight: bold;
  font-size: 14px;
  color: ${props => props.theme.color.grey};
  letter-spacing: 1px;
  height: 60px;
  display: block;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  background: ${props => props.theme.color.yellow};
  border-radius: 0 4px 4px 0;
  padding: 0px 24px;
  border-width: 0px;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  outline: 0px;
  &:hover {
    box-shadow: rgba(110, 120, 152, 0.22) 0px 2px 10px 0px;
  }
  @media (max-width: ${props => props.theme.screen.md}) {
  }
  @media (max-width: ${props => props.theme.screen.sm}) {
    margin-left: 0;
    border-radius: 4px;
  }
`
const FormSubtitle = styled.span`
  ${props => props.theme.font_size.xxsmall}
  color: red;
`
